module.exports = __webpack_public_path__ + "static/media/protocol.d4f808b2.htm";